import { get, writable } from "svelte/store";
import API from "../../../API/API";
import Feature from "../../../Branding/Feature";
import User from "../../../Branding/User";
import LoadState from "../../../Enums/LoadState";
import Image from "../../../Models/Image";
import ImageCollection from "../../../Models/ImageCollection";
import VesselCommentThread from "../../../Models/VesselCommentThread";
import ConfirmDialogData from "../../../UI/ConfirmDialog/ConfirmDialogData";

const CompanyStore = {
	dashboard: {
		meta: {
			visible: writable(false),
			loadState: writable(LoadState.INIT),
			error: writable("")
		},
		data: {
			currentUser: writable(null),
			imageCollections: writable(null),
			images: writable(null),
			vesselCommentThreads: writable({}), // Arrays indexed by spire id
			vesselCommentThreadDetails: writable({}) // Arrays indexed by spire id
		},
		confirmDialog: new ConfirmDialogData(),
		actions: {
			init: () => {
				if (get(CompanyStore.dashboard.meta.loadState) !== LoadState.INIT) {
					return;
				}

				CompanyStore.dashboard.meta.loadState.set(LoadState.LOADING);

				const onError = (error) => {
					console.error("error", error);
					CompanyStore.dashboard.meta.error.set(error.data.detail);
					CompanyStore.dashboard.meta.loadState.set(LoadState.INIT);
				};

				// ^AG: This is little bit of a mess. Consider ES6 await.
				API.currentUser()
					.then((response) => {
						const userResponse = response;
						console.log("userResponse", userResponse);
						CompanyStore.dashboard.data.currentUser.set(userResponse);

						const promises = [];
						if (User.hasFeature(Feature.IMAGE_ASSETS.EDIT)) {
							const imageSetsPromises = API.get("image-sets")
								.then((response) => {
									const imageSetsResponse = response;
									console.log("imageSetsResponse", imageSetsResponse);
									const imageCollections = [];
									for (let i = 0; i < imageSetsResponse.length; i++) {
										if (imageSetsResponse[i].owner_company_id !== userResponse.company.id) {
											continue;
										}
										const collection = new ImageCollection(imageSetsResponse[i]);
										// collection.store = ImageCollectionsStore;
										for (let j = 0; j < imageSetsResponse[i].images.length; j++) {
											const image = new Image(imageSetsResponse[i].images[j]);
											image.collection = collection;
											collection.images.push(image);
										}
										imageCollections.push(collection);
									}
									CompanyStore.dashboard.data.imageCollections.set(imageCollections);
								})
								.catch(onError);

							const imagesPromise = API.get("images?subset=company-owned")
								.then((response) => {
									const imagesResponse = response;
									console.log("imagesResponse", imagesResponse);
									const images = [];
									for (let i = 0; i < imagesResponse.length; i++) {
										const image = new Image(imagesResponse[i]);
										images.push(image);
									}
									CompanyStore.dashboard.data.images.set(images);
								})
								.catch(onError);

							promises.push(imageSetsPromises);
							promises.push(imagesPromise);
						}
						if (User.hasAnyOfFeatures([Feature.MARITIME.VESSEL_COMMENTS.VIEW, Feature.MARITIME.VESSEL_COMMENTS.EDIT])) {
							const commentsPromise = API.get("comments/vessel")
								.then((response) => {
									const comments = response;
									const { threadBySpireId, detailsBySpireId } = VesselCommentThread.helpers.processList(comments.threads);
									CompanyStore.dashboard.data.vesselCommentThreads.set(threadBySpireId);
									CompanyStore.dashboard.data.vesselCommentThreadDetails.set(detailsBySpireId);
								});
							promises.push(commentsPromise);
						}

						Promise.all(promises)
							.then((responses) => {
								CompanyStore.dashboard.meta.loadState.set(LoadState.LOADED);
							});
					})
					.catch(onError);
			}
		}
	}
};
export default CompanyStore;
